export default "__VITE_ASSET__B2j6MmS5__"